import * as colors from '@atlaskit/theme/colors';
export var thumb = {
  default: {
    background: colors.N0,
    border: colors.N800
  },
  focus: {
    background: colors.N0,
    border: colors.B100
  }
};
export var track = {
  default: {
    lower: colors.B400,
    upper: colors.N30
  },
  disabled: {
    lower: colors.N50,
    upper: colors.N30
  },
  hover: {
    lower: colors.B300,
    upper: colors.N40
  }
};